export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  SOCIAL: '/social',
  PROFILE: '/profile',
  PARTNERSHIPS: '/partnerships',
  CAMPAIGNS: '/campaigns',
  POINTS: '/points', // Alias for backward compatibility, route renamed to "Points"
  RESTAURANTS: '/restaurants',
  FOOD_AREA_RESTAURANTS: '/food-areas/:foodAreaId/restaurants',
  REDEEM_POINTS: '/redeem-points',
  REDEEM_POINTS_RESTARUANT: '/redeem-points-restaurant',
  MY_COUPONS: '/my-coupons',
  RESTAURANT_DETAILS: '/restaurant',
  REFER_AND_EARN: '/refer-and-earn',
  REFERRAL_LANDING: '/r/:code',
  RESERVATIONS: '/reservations',
  MENU_SCAN_LOADING: '/menu-scan-loading',
  MENU_SCAN_RESULTS: '/menu-scan-results',
  MENU_SAVE_SUCCESS: '/menu-save-success',
  SAVED_MENU_DETAIL: '/menu',
  SEARCH: '/search',
  // Group Dining Sessions ("Calendly for dinner"). DINE = anonymous create flow;
  // DINE_SESSION = the shareable, anon-friendly session/join page (/dine/:shareToken).
  DINE: '/dine',
  DINE_SESSION: '/dine/:shareToken',
  ONBOARD: '/onboard',
  REWARDS_INFO: '/rewards',
  SUBSCRIPTION_SUCCESS: '/subscription/success',
  SUBSCRIPTION_CANCELED: '/subscription/canceled',
  UNAUTHORIZED: '/unauthorized',
  DASHBOARD: '/dashboard',
  CHEF_DASHBOARD: '/chef-dashboard',
  RECOVER_ACCOUNT: '/recover-account',
  RECOVER_BLOCKED_ACCOUNT: '/recover-blocked-account',
  SITEMAP: '/sitemap',
  NOTFOUND: '/404',

  // Restaurant Admin Routes
  RESTAURANT_ADMIN_PENDING: '/restaurant/pending',
  RESTAURANT_ADMIN_DASHBOARD: '/restaurant/dashboard',
  RESTAURANT_MENUS: '/restaurant/menus',
  RESTAURANT_REVIEWS: '/restaurant/reviews',
  RESTAURANT_RECOMMENDATIONS: '/restaurant/recommendations',
  RESTAURANT_NOTIFICATIONS: '/restaurant/notifications',
  RESTAURANT_MESSAGES: '/restaurant/messages',
  RESTAURANT_SETTINGS: '/restaurant/settings',
  RESTAURANT_SUBSCRIPTION: '/restaurant/subscription',
  RESTAURANT_INFLUENCER: '/restaurant/influencer',
  RESTAURANT_LEADERBOARD: '/restaurant/leaderboard',

  // SEARCH_ROUTE: '/search',
  // VIEW_ALL_ROUTE: '/all',
  // PERSONALIZE_ROUTE: '/personalize',
  // ROLE_ROUTE: '/choose-your-role',
  // STORY_ROUTE: '/share-your-dining-story',
  // CHEF_BIO_ROUTE: '/share-your-bio',
  // MISSING_ROUTE: '/a-few-more-details',
  // FIND_RESTAURANT_ROUTE: '/find-restaurant',
  // REQUEST_ONBOARDING: '/request-onboarding',
  // GROUP: '/group',
  // ONBOARDING: '/onboarding',
}

export const CHILD_ROUTES = {
  BIO: 'bio',
  SAVED_RESTAURANTS: 'saved-restaurants',
  PREFERENCES: 'preferences',
  REVIEWS: 'reviews',
  RESTAURANT_CAMPAIGNS: 'campaigns',
  RESTAURANT_COLLAB_INBOX: 'collab-inbox',
  RESTAURANT_FIND_CREATORS: 'find-creators',
}

export const navBarRoutes = [
  {
    name: 'Home',
    path: ROUTES.HOME,
    isPublic: true,
  },
  // Planner — a first-class, anon-friendly entry point into the "plan a group dinner" flow
  // (companion to the Home CTA and the mobile bottom-nav Planner tab). Labelled "Planner" to match
  // the landing screen's language; the route (/dine) and every existing share link are unchanged.
  {
    name: 'Planner',
    path: ROUTES.DINE,
    isPublic: true,
  },
  {
    name: 'About',
    path: ROUTES.ABOUT,
    isPublic: true,
  },
  {
    name: 'Rewards',
    path: ROUTES.REWARDS_INFO,
    isPublic: true,
  } /* ,
  {
    name: 'Campaigns',
    path: ROUTES.CAMPAIGNS,
    isPublic: true,
  },
  {
    name: 'Partnerships',
    path: ROUTES.PARTNERSHIPS,
    isPublic: false,
  } */,
  // Social removed from navigation - accessible via Home screen "Groups & Conversations" section and Profile menu
  // Soft-launch: Leaderboard temporarily hidden from navigation
  {
    name: 'Points',
    path: ROUTES.POINTS,
    isPublic: false,
  },
]
